import PlacesAutocomplete from './places-autocomplete'

export default PlacesAutocomplete
